export default __webpack_public_path__ + "static/media/rocket_anim_11.c87cefe9.png";